export default {
  // 查询客户存油详情
  selectYgnCustStorageByStorageId: '/ygsjzs/ygnCustStorage/selectYgnCustStorageByStorageId',
  // 分页查询客户存油列表
  selectYgnCustStorageByPage: '/ygsjzs/ygnCustStorage/selectYgnCustStorageByPage'
}
